export const openInSmallWindow = (url: string, width = 520, height = 570) => {
    const top = ((window.screen.height / 2) - (height / 2)) / 2;
    const left = (window.screen.width / 2) - (width / 2);
    window.open(
        url,
        '__blank',
        `location=yes,height=${ height },width=${ width },top=${ top },left=${ left },scrollbars=yes,status=yes`
    );
};
